<template>
  <el-select v-model="course_id" clearable filterable :placeholder="placeholder">
    <el-option v-for="item in $store.state.courses" :key="item.id" :label="item.name" :value="item.id">{{ item.name }}
    </el-option>
  </el-select>
</template>

<script>
export default {
  name: "CourseSelect",
  props: {
    value: [String, Number],
    nostore: Boolean,
    placeholder: String,
  },
  computed: {
    course_id: {
      get() {
        if (this.value === undefined || this.value === null || this.value === '') {
          const cid = this.$store.state.currentCourseId;
          if (cid !== this.value) {
            this.$emit('input', cid);
          }
          return cid;
        }
        return Number.parseInt(this.value);
      },
      set(val) {
        if (val === '') {
          val = null;
        }
        this.nostore || this.$store.commit('updateCurrentCourse', val);
        this.$emit('input', val);
      }
    }
  }
}
</script>